import React from 'react'
import ReactDOM from 'react-dom/client';
import './index.css'
import WithInfoMain from 'pages/web/frame/WithInfoMain';
import WithInfoMobileMain from 'pages/mobile/frame/WithInfoMain';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import * as serviceWorker from 'serviceWorker';
import { BrowserRouter as Router } from 'react-router';
import { PersistGate }  from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { isMobile } from 'react-device-detect';

const persistor = persistStore(store);

persistor.flush().then(() => {
  persistor.purge();
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}> 
        <Router>
          {
            !isMobile ? 
            <WithInfoMain /> :
            <WithInfoMobileMain />
          }
        </Router>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

persistor.subscribe(() => {
  if (persistor.getState().bootstrapped) {
    document.getElementById('loading')!.style.display = 'none';
    document.getElementById('root')!.style.display = 'block';
  }
});

serviceWorker.unregister();
